import { Directive, HostBinding, Input } from '@angular/core';

import { BarComponent } from './bar.component';

// todo: progress element conflict with bootstrap.css
// todo: need hack: replace host element with div

export class ProgressDirective  {
  /** if `true` changing value of progress bar will be animated (note: not supported by Bootstrap 4) */
   public animate:boolean;

  /** maximum total value of progress element */
  
  
  public get max():number {
    return this._max;
  }

  public set max(v:number) {
    this._max = v;
    this.bars.forEach((bar:BarComponent) => {
      bar.recalculatePercentage();
    });
  }

   public addClass:boolean = true;

  public bars:any[] = [];

  protected _max:number = 100;

  public addBar(bar:BarComponent):void {
    if (!this.animate) {
      bar.transition = 'none';
    }
    this.bars.push(bar);
  }

  public removeBar(bar:BarComponent):void {
    this.bars.splice(this.bars.indexOf(bar), 1);
  }
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{selector: 'bs-progress, [progress]'}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'animate': [{ type: Input },],
'max': [{ type: HostBinding, args: ['attr.max', ] },{ type: Input },],
'addClass': [{ type: HostBinding, args: ['class.progress', ] },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
